import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { setBadge } from 'modules/common/utils';
import { colors, dimensions } from 'modules/common/styles';
import { Tip, Label } from 'modules/common/components';
import { localStore } from 'helpers';
import { withRouter } from 'react-router';

const LeftNavigation = styled.aside`
  width: ${dimensions.headerSpacingWide}px;
  background: ${colors.colorPrimaryDark};
  z-index: 10;
  flex-shrink: 0;
  overflow: hidden;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;

  > a {
    display: flex;
    margin-top: ${dimensions.unitSpacing}px;
    height: ${dimensions.headerSpacing}px;
    justify-content: center;
    align-items: center;

    img {
      max-height: 28px;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.1);
      }
    }
  }
`;

const Nav = styled.nav`
  display: block;
  margin-top: ${dimensions.unitSpacing}px;
  height: calc(100% - 130px);
  overflow: auto;

  > a {
    display: block;
    height: ${dimensions.headerSpacing + 10}px;
    text-align: center;
    position: relative;
    transition: all 0.3s ease;

    i {
      opacity: 0.8;
      transition: all 0.3s ease;
    }

    span {
      position: absolute;
      right: 12px;
      bottom: 12px;
      padding: 4px;
      min-width: 19px;
      min-height: 19px;
    }

    &.active {
      background: rgba(0, 0, 0, 0.13);

      &:before {
        content: '';
        width: 4px;
        background: ${colors.colorCoreTeal};
        position: absolute;
        display: block;
        right: 0;
        top: 0;
        bottom: 0;
        border-radius: 5px;
      }

      i {
        opacity: 1;
      }
    }

    &:focus {
      outline: 0;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.05);

      i {
        opacity: 1;
      }
    }

    @media (max-height: 760px) {
      height: ${dimensions.headerSpacing}px;

      i {
        line-height: ${dimensions.headerSpacing}px;
      }
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

const NavIcon = styled.i`
  font-size: 16px;
  line-height: ${dimensions.headerSpacing + 10}px;
  color: ${colors.colorWhite};
  img {
    width: 18px;
  }
`;

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      name: ''
    };
  }

  componentDidUpdate() {
    const { __ } = this.context;
    setBadge(this.props.unreadConversationsCount, __('Inbox'));
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.unreadConversationsCount > this.props.unreadConversationsCount
    ) {
      // const audio = new Audio('/sound/notify.mp3');
      // audio.play();
    }
  }

  render() {
    const { unreadConversationsCount } = this.props;
    let { __, currentUser } = this.context;
    currentUser = currentUser || {};
    let agentRole = currentUser.role || '';
    let isOrgSelected = localStore.getItem('selected-tenant');

    return (
      <LeftNavigation>
        <NavLink to="/">
          <img src="/images/robots/logo.svg" alt="stream" />
        </NavLink>
        {/* {global.currentUser &&
            global.currentUser.allowAccess &&
            global.currentUser.allowAccess.indexOf('INBOX') !== -1 && (
              <Tip placement="right" text={__('Inbox')}>
                <NavLink to="/inbox" activeClassName="active">
                  <NavIcon>
                    <img src="/images/chat.png"></img>
                  </NavIcon>
                  {unreadConversationsCount !== 0 && (
                    <Label shake lblStyle="danger" ignoreTrans>
                      {unreadConversationsCount}
                    </Label>
                  )}
                </NavLink>
              </Tip>
            )} */}
        {!isOrgSelected && (
          <Nav>
            <Tip placement="right" text={__('Organization')}>
              <NavLink to="/organization" activeClassName="active">
                <NavIcon>
                  <img src="/images/customers.png"></img>
                </NavIcon>
              </NavLink>
            </Tip>
            <Tip placement="right" text={__('billing')}>
              <NavLink to="/billing" activeClassName="active">
                <NavIcon>
                  <img src="/images/customers.png"></img>
                </NavIcon>
              </NavLink>
            </Tip>
          </Nav>
        )}
        {isOrgSelected && (
          <Nav>
            <Tip placement="right" text={__('Dialpad')}>
              <NavLink to="/dial-pad" activeClassName="active">
                <NavIcon>
                  <img src="/images/inboundcall.png"></img>
                </NavIcon>
              </NavLink>
            </Tip>
            <Tip placement="right" text={__('Dashboard')}>
              <NavLink to="/dashboard" activeClassName="active">
                <NavIcon>
                  <img src="/images/Dashboard.png"></img>
                </NavIcon>
              </NavLink>
            </Tip>
            <Tip placement="right" text={__('Reporting')}>
              <NavLink to="/reporting" activeClassName="active">
                <NavIcon>
                  <img src="/images/report.png"></img>
                </NavIcon>
              </NavLink>
            </Tip>
            {/* <Tip placement="right" text={__('Insights')}>
              <NavLink to="/insights" activeClassName="active">
                <NavIcon>
                  <img src="/images/insight.png"></img>
                </NavIcon>
              </NavLink>
            </Tip> */}
            <Tip placement="right" text={__('Teams')}>
              <NavLink to="/team" activeClassName="active">
                <NavIcon>
                  <img src="/images/team.png"></img>
                </NavIcon>
              </NavLink>
            </Tip>
            {/* <Tip placement="right" text={__('Queue - Inbound call')}>
            <NavLink to="/inboundcall" activeClassName="active">
              <NavIcon>
                <img src="/images/inboundcall.png"></img>
              </NavIcon>
            </NavLink>
          </Tip> */}
            <Tip placement="right" text={__('Campaign')}>
              <NavLink to="/campaigns" activeClassName="active">
                <NavIcon>
                  <img src="/images/campaign.png"></img>
                </NavIcon>
              </NavLink>
            </Tip>
            {/* <Tip placement="right" text={__('Flow')}>
            <NavLink to="/flow" activeClassName="active">
              <NavIcon>
                <img src="/images/flow.png"></img>
              </NavIcon>
            </NavLink>
          </Tip> */}
            <Tip placement="right" text={__('Settings')}>
              <NavLink to="/settings" activeClassName="active">
                <NavIcon>
                  <img src="/images/settings.png"></img>
                </NavIcon>
              </NavLink>
            </Tip>
          </Nav>
        )}
      </LeftNavigation>
    );
  }
}

Navigation.propTypes = {
  unreadConversationsCount: PropTypes.number
};

Navigation.contextTypes = {
  __: PropTypes.func,
  currentUser: PropTypes.object
};

export default withRouter(Navigation);



// WEBPACK FOOTER //
// src/modules/layout/components/Navigation.js